// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"alpha"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 4L5 12.5L19 21M13 3V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AlphaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'alpha',
    ref,
    icon: element,
  },
));

AlphaIcon.displayName = 'AlphaIcon';

export default AlphaIcon;
